import * as _ from "lodash";

// Validation helper for Email
export class EmailValidation{

    /**
     * Validate email format
     *
     * @param {any} elementValue.
     * @return {string} errorMessages.
     */
    validate = (elementValue:any): string => {
    	const EmailRegx = /^[A-Za-z0-9!#$%&'*+\-/=?^_`{|}~.]+@[A-Za-z0-9!#$%&'*+\-/=?^_`{|}~.]+$/;
		const checkConsecutiveDots = /\.{2,}/u; // Multiple consecutive dots
		const shouldnotStrtwithdot = /^\./u;  //Local-part starts with dot

    	const ElementValue = (elementValue ||"").toString().trim().replace(/,/gi, ";");

    	const Emails = ElementValue.toString().split(";");
	
    	if(_.isEqual(ElementValue.toString().replace(/;/gi, "").trim().length, 0)){
    		return `${(elementValue ||"").toString().trim()} is not a valid email address.`;
    	}
    	const EmailAddresses = [];
    	for(const email of Emails){
    		const EmailAddress = (email || "").toString().trim();
    		const isValidEmail = EmailRegx.test(EmailAddress);

    		if(!isValidEmail && !_.isEqual(EmailAddress.length, 0)){
    			return `${EmailAddress} is not a valid email address.`;
    		}
			if(checkConsecutiveDots.test(EmailAddress) && isValidEmail){
				return `${EmailAddress} is not a valid email address.`;
			}
			if(shouldnotStrtwithdot.test(EmailAddress) && isValidEmail){
				return `${EmailAddress} is not a valid email address.`;
			}

    		else{
    			if(!_.isEqual(EmailAddresses.indexOf(EmailAddress), -1)
                && !_.isEqual(EmailAddress.length, 0)){
    				return `${EmailAddress} is duplicate email address.`;
    			}
    			else{
    				EmailAddresses.push(EmailAddress);
    			}
    		}
    	}
    	return "";
    }
}